/**
 * Mutation argument for create is the body; update is `{id, data}`.
 *
 * @param {Object} arg Mutation arguments.
 * @return {Object|undefined}
 */
export function purchaseOrderFacilityCostingMutationPayload(arg) {
  if (arg != null && Object.prototype.hasOwnProperty.call(arg, "data")) {
    return arg.data;
  }
  return arg;
}

/**
 * Returns facility-costing cache tags affected by a consented PO write.
 *
 * Direct costing create/update already drop these tags. A PO save with
 * `sync_facility_costing: true` writes the same bands, so the Facilities
 * Costings list and the product picker must refetch or they keep the old
 * unit price. Do not also wipe `productsBasedSupplier` to `[]` — an empty
 * picker hides bands until supplier or warehouse changes.
 *
 * @param {*} _result Mutation result.
 * @param {*} error Mutation error.
 * @param {Object} arg Mutation arguments.
 * @return {Array<string|Object>} Tags that must be invalidated.
 */
export function purchaseOrderFacilityCostingInvalidationTags(_result, error, arg) {
  if (error) return [];
  const payload = purchaseOrderFacilityCostingMutationPayload(arg);
  if (payload?.sync_facility_costing !== true) return [];
  return [
    "WarehouseCostingList",
    "WarehouseCostingSelection",
    { type: "WarehouseCostingDetail" },
    "ProductWarehouseCosting",
  ];
}
